export default defineAppConfig({
  sexologyUpsellEnabled: true,
});

declare module '@nuxt/schema' {
  interface AppConfigInput {
    sexologyUpsellEnabled?: boolean
  }
}
